export default {
  share: {
    fullUrl: 'Komplett',
    shortUrl: 'Kurz',
    urlCopied: 'URL kopiert',
    clickToCopy: 'Klicken Sie, um die URL zu kopieren',
    share: 'Teilen (zum Kopieren klicken)',
    shareLink: 'Link teilen',
    short: 'Kurz-URL',
    copyUrlInfo: 'Sie können den Link auch aus der Adressleiste Ihres Browsers kopieren.',
    urlShortened: 'URL gekürzt',
    shorteningNotPossible: 'Keine gekürzte URL verfügbar. Bitte verwenden Sie die vollständige URL.',
    embedCodeCopied: 'Code zur Einbettung kopiert',
    embed: 'Einbindung auf anderer Website (zum Kopieren anklicken)',
    embedInstructions: 'Dieses Code-Fragment zur Einbindung der Karte auf Ihrer Website benutzen'
  }
}
